module.exports = __webpack_public_path__ + "img/feather_icon_search.5437e521.svg";